<h2 mat-dialog-title>
	{{ data.title }}
</h2>

<mat-dialog-content class="container">
	<form [formGroup]="form" class="row g-1" style="min-width: 360px">
		@for (f of data.fields; track f.key) {
			@switch (f.type) {
				@case (FieldType.TEXT) {
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>{{ f.label }}</mat-label>
						<input matInput [placeholder]="f.placeholder" [formControlName]="f.key" />
					</mat-form-field>
				}
				@case (FieldType.NUMBER) {
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>{{ f.label }}</mat-label>
						<input matInput type="number" [placeholder]="f.placeholder" [formControlName]="f.key" />
					</mat-form-field>
				}
				@case (FieldType.EMAIL) {
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>{{ f.label }}</mat-label>
						<input matInput type="email" [placeholder]="f.placeholder" [formControlName]="f.key" />
					</mat-form-field>
				}
				@case (FieldType.PHONE) {
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>{{ f.label }}</mat-label>
						<input matInput [placeholder]="f.placeholder" [formControlName]="f.key" />
					</mat-form-field>
				}
				@case (FieldType.TEXTAREA) {
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>{{ f.label }}</mat-label>
						<textarea matInput rows="3" [placeholder]="f.placeholder" [formControlName]="f.key"></textarea>
					</mat-form-field>
				}
				@case (FieldType.SELECT) {
					<mat-form-field [appearance]="appearance">
						<mat-label>{{ f.label }}</mat-label>
						<input
							matInput
							[placeholder]="f.placeholder"
							[formControlName]="f.key"
							[matAutocomplete]="dynamicAutocomplete"
						/>
						<mat-autocomplete [displayWith]="getDisplayFn(f)" #dynamicAutocomplete="matAutocomplete">
							@for (option of f.options; track option.id) {
								<mat-option
									[value]="f.apiOptions.valueApiKey ? option[f.apiOptions.valueApiKey] : option"
								>
									{{ option[f.apiOptions.labelApiKey] }}
								</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
				}
				@default {
					<mat-form-field [appearance]="appearance" class="w-100">
						<mat-label>{{ f.label }}</mat-label>
						<input matInput [placeholder]="f.placeholder" [formControlName]="f.key" />
					</mat-form-field>
				}
			}
		}
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="onCancel()">Anuluj</button>
	<button mat-raised-button color="primary" [disabled]="form.invalid" (click)="onSave()">Zapisz</button>
</mat-dialog-actions>
